var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pos-relative nav-pill rounded-full px py-1 cursor-pointer text-nowrap",class:_vm.classes,on:{"click":_vm.onClick,"mouseenter":function($event){_vm.hovered = true},"mouseleave":function($event){_vm.hovered = false}}},[_vm._v("\n    "+_vm._s(_vm.title)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }